import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useMemo, useState } from 'react';

import { GeneralTable, SingleIconButton } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { EstadoIpv4Choices, IPDisponibles, Ipv4 } from '@/shared/interfaces';
import IPvDetailCellPrimaryText from './IPvDetailCellPrimaryText';
import { MRT_ColumnDef } from 'material-react-table';
import { useFetchIpv4 } from '@/shared/actions/erp';
import { humanizeStateChoice, useTableFilter, useTableServerSideFiltering } from '@/shared';

export type IPv4DetailsCellProps = {
  availableIps: IPDisponibles[];
  ipv4Group?: string;
};

const IPv4DetailsCell: React.FC<IPv4DetailsCellProps> = ({ availableIps, ipv4Group }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const {
      pagination,
      setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;



  const {
    data : dataIpv4s,
    isLoading: isLoadingIpv4s,
  } = useFetchIpv4({
    enabled : !!ipv4Group && isOpen,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      grupo_ipv4: ipv4Group,
      ...filterObject
    },
  })

  const columnsIPv4Details = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "estado_ip",
        header: "Estado",
        size: 50,
        filterVariant: 'select',
        filterSelectOptions: EstadoIpv4Choices?.map(type => ({
          label: humanizeStateChoice(type),
          value: type,
        })),
        enableSorting: false,
      },
      {
        accessorKey: "ip",
        header: "ip",
        size: 100,
      },
      {
        accessorKey: "contrato",
        header: "contrato",
        Cell: ({ row }) => row.original?.contrato || 'No asociado'
      },
      {
        accessorKey: "codigo",
        header: "codigo",
      },
    ],
    []
  );

  return (
    <>
      <SingleIconButton
        startIcon={<VisibilityIcon />}
        color={'default' as any}
        label="Ver detalle"
        onClick={() => setIsOpen(true)}
      />

      <ScrollableDialogProps
        title="Detalle de IPs"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        cancelTextBtn="Cerrar"
        contentNode={
          <Grid container spacing={2}>
            {
              !!ipv4Group && availableIps.length==0?
                <GeneralTable<Ipv4>
                  columns={columnsIPv4Details}
                  data={dataIpv4s?.data?.data || []}
                  isLoading={isLoadingIpv4s}
                  // // search
                  enableGlobalFilter={false}
                  // // filters - llega al back
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}
                  // // pagination
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={dataIpv4s?.data?.count}
                  // // actions ========
                  enableColumnActions={false}
                  enableEditing={false}
                  // crud
                  canEdit={false}
                  // onEdit={onEdit}
                  canDelete={false}
                  // onDelete={onDelete}

                />
              :<>
                {availableIps.map((ip, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                        <List>
                          <ListItem>
                            <ListItemIcon>
                              {ip?.estado ? (
                                <LockOpenIcon color="success" />
                              ) : (
                                <LockPersonIcon color="info" />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary={<IPvDetailCellPrimaryText ip={ip?.ip || ''} />}
                              secondary={
                                <Typography variant="body2" color="textSecondary">
                                  {ip.estado ? 'Disponible' : 'Ocupado'}
                                </Typography>
                              }
                            />
                          </ListItem>
                        </List>
                  </Grid>
                ))}
              </>
            }
          </Grid>
        }
      />
    </>
  );
};

export default IPv4DetailsCell;
